import React, { useEffect, useRef, useState } from "react";
import { BusinessContactProps } from "./business-contact.props";
import "./business-contact.css";
import { BusinessContactViewModel } from "./business-contact.view-model";
import { useAuth } from "../auth/auth-context";
import LoadingPlaceHolder from "src/components/molecules/loading/loading-placeholder";
import PhoneNumberInput from "src/components/atoms/phone-number-input/phone-number-input";
import { IContactModel } from "src/types/models/apiModels";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";

const BusinessContact: React.FC<BusinessContactProps> = ({
	editContact,
	useLoggedInUser,
	onChange,
}) => {
	const { user } = useAuth(); // Extract user from useAuth hook
	const [loading, setLoading] = useState(true);
	const [contact, setContact] = useState<IContactModel | undefined>(
		editContact
	);
	const viewModel = useRef<BusinessContactViewModel | null>(null);

	useEffect(() => {
		const fetchData = async () => {
			setLoading((prevValue) => {
				if (!prevValue) {
					return true;
				}
				return prevValue;
			});
			try {
				if (user && user.accessToken) {
					viewModel.current = new BusinessContactViewModel(
						user.accessToken
					);
					const response = await viewModel.current?.initContact(
						useLoggedInUser ?? false,
						user
					);
					setContact(() => response);
				}
			} catch (error) {
				console.error("Error fetching initBusiness:", error);
			} finally {
				setLoading((prevValue) => {
					if (prevValue) {
						return false;
					}
					return prevValue;
				});
			}
		};

		fetchData();
	}, [user]);

	useEffect(() => {
		if (onChange && contact) {
			onChange(contact);
		}
	}, [contact]);

	if (loading) {
		return (
			<LoadingPlaceHolder message="We're setting things up for you. Just a moment!" />
		);
	}

	return (
		<>
			<div className="flex flex-col items-center justify-center gap-8 w-full">
				<div className="flex items-center justify-start gap-2 w-full">
					<span className="font-Poppins font-medium text-2xl uppercase tracking-wider">
						Primary Contact
					</span>
				</div>
				<div className="flex flex-col items-center justify-start gap-6 w-full">
					<div className="flex items-center justify-start gap-2 w-full">
						<div className="flex items-center justify-start gap-2 w-full">
							<InputBox
								label={"First Name"}
								type={"text"}
								onChange={() => console.log(``)}
								value={contact?.firstName ?? ""}
								disabled
							></InputBox>
						</div>
						<div className="flex items-center justify-start gap-2 w-full">
							<InputBox
								label={"Family Name"}
								type={"text"}
								onChange={() => console.log(``)}
								value={contact?.lastName ?? ""}
								disabled
							></InputBox>
						</div>
					</div>
					<div className="flex items-center justify-start gap-2 w-full">
						<div className="flex items-center justify-start gap-2 w-full">
							<InputBox
								label={"Email Address"}
								type={"text"}
								onChange={() => console.log(``)}
								value={contact?.emailId ?? ""}
								disabled
							></InputBox>
						</div>
						<div className="flex items-center justify-start gap-2 w-full">
							<PhoneNumberInput
								value={
									contact?.phoneNumber ?? {
										countryCode: "",
										number: "",
									}
								}
								disabled={true}
							/>
						</div>
					</div>
				</div>
				{/* <div className="flex items-center justify-end gap-6 w-full">
					<ButtonAddNew
						text="Invite members"
						onClick={function (): void {
							throw new Error("Function not implemented.");
						}}
						disabled
					></ButtonAddNew>
				</div> */}
			</div>
		</>
	);
};

export default BusinessContact;
